import React from "react";
import Icon from "./Icon";

const VARIANTS = {
  info: { icon: "info", className: "status-banner-info" },
  warning: { icon: "flame", className: "status-banner-warning" },
  error: { icon: "target", className: "status-banner-error" },
};

export default function StatusBanner({
  variant = "info",
  title,
  message,
  actionLabel,
  onAction,
}) {
  const current = VARIANTS[variant] || VARIANTS.info;
  return (
    <div className={`status-banner ${current.className}`}>
      <Icon name={current.icon} size={20} className="status-banner-icon" />
      <div className="status-banner-content">
        {title && <div className="status-banner-title">{title}</div>}
        {message && <div className="status-banner-message">{message}</div>}
      </div>
      {actionLabel && onAction && (
        <button className="status-banner-action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
